// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3F4Wi","label":"Completed_label__2KdAe"};